<header class="barra-superior-contenedor">
  <div class="izquierda-contenedor">
    <button mat-icon-button class="btn-menu-mobile" (click)="toggleMenu()">
      <mat-icon>menu</mat-icon>
    </button>
    @if (accionAtras()) {
      <button mat-icon-button class="btn-atras" (click)="accionAtras()!()">
        <mat-icon>arrow_back</mat-icon>
      </button>
    }
    <div class="titulo-modulo" [class.con-contenido-personalizado]="!!contenidoPersonalizado()" [class.sin-titulo]="!tituloActual()">
      @if (iconoSvgTitulo()) {
        <mat-icon [svgIcon]="iconoSvgTitulo()!" class="titulo-icono-barra"></mat-icon>
      }
      @if (tituloActual()) {
        <h2>{{ tituloActual() }}</h2>
      }
    </div>
    @if (contenidoPersonalizado()) {
      <div class="contenido-personalizado">
        <ng-container *ngTemplateOutlet="contenidoPersonalizado()"></ng-container>
      </div>
    }
  </div>

  <div class="perfil-usuario">
    @if (waSaldo$ | async; as saldo) {
      <div class="wa-indicador" [ngClass]="getWaClase(saldo)">
        <img src="assets/svg/whatsapp.svg" alt="WhatsApp" class="wa-icono">
        <span class="wa-contador">{{ saldo.wa_current_usage }}/{{ saldo.wa_monthly_limit + saldo.wa_extra_balance }}</span>
      </div>
    }

    @if (usuario$ | async; as usuario) {
    <button mat-button [matMenuTriggerFor]="menuPerfil" class="menu-trigger">
      <div class="menu-trigger-contenido">
        <img class="avatar" src="assets/svg/persona.svg" alt="Avatar de usuario">

        <div class="info-usuario">
          <span class="nombre">{{ usuario.nombre }} {{ usuario.apellidos }}</span>
          <span class="rol">{{ servicioSesion.obtenerRolLegible() }}</span>
        </div>
        
        <mat-icon>expand_more</mat-icon>
      </div>
    </button>
    }

    <mat-menu #menuPerfil="matMenu">
      <button mat-menu-item (click)="cambiarPerfil()">
        <mat-icon>cached</mat-icon>
        <span>Cambiar de Perfil</span>
      </button>

      <button mat-menu-item (click)="toggleModoOscuro()">
        <mat-icon>{{ modoOscuro() ? 'light_mode' : 'dark_mode' }}</mat-icon>
        <span>{{ modoOscuro() ? 'Modo claro' : 'Modo oscuro' }}</span>
      </button>

      <mat-divider></mat-divider>
      <button mat-menu-item (click)="cerrarSesion()">
        <mat-icon>exit_to_app</mat-icon>
        <span>Cerrar Sesión</span>
      </button>
    </mat-menu>
  </div>
</header>
